import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import DeliveryWarranty from "./pages/DeliveryWarranty";
import Occasion from "./pages/Occasion";
import Neuf from "./pages/Neuf";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="boutique" element={<Shop />} />
              <Route path="produit/:id" element={<ProductDetail />} />
              <Route path="panier" element={<Cart />} />
              <Route path="commander" element={<Checkout />} />
              <Route path="magasin" element={<About />} />
              <Route path="services" element={<Contact />} />
              <Route path="contact" element={<Contact />} />
              <Route path="livraison-garantie" element={<DeliveryWarranty />} />
              <Route path="occasion" element={<Occasion />} />
              <Route path="neuf" element={<Neuf />} />
              <Route path="admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
